<template>
  <v-app>
    <the-banner/>
    <v-content>
      <router-view/>
    </v-content>
    <the-footer/>
    <c-snackbar/>
    <c-blocker/>
    <c-confirm/>
  </v-app>
</template>

<script>
import TheBanner from '@/components/layout/TheBanner';
import TheFooter from '@/components/layout/TheFooter';

export default {
  components: { TheBanner, TheFooter }
};
</script>